module.exports = __webpack_public_path__ + "static/media/item-row-purple.a5ceafea.png";